(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kdg-asesor"]) return;
  try {
    
class TpAsesor extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.hdt-tp-asesor__btn');
    this.panel = this.querySelector('.hdt-tp-asesor__panel');
    this.closeBtn = this.querySelector('.hdt-tp-asesor__close');

    this.btn.addEventListener('click', () => this.toggle());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.toggle(false));

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.toggle(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.toggle(false);
    });
  }

  toggle(force) {
    const open = force === undefined ? this.panel.hidden : force;
    this.panel.hidden = !open;
    this.btn.setAttribute('aria-expanded', String(open));
    this.classList.toggle('is-open', open);
  }
}

if (!customElements.get('tp-asesor')) {
  customElements.define('tp-asesor', TpAsesor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kdg-tp-fila"] && !Shopify.designMode) return;
  try {
    
/* Respaldo para navegadores sin scroll-driven animations (Safari, Firefox).
   En Chrome/Edge no hace nada: el CSS ya mueve la fila. */
(function () {
  if (window.__tpfInit) return;
  window.__tpfInit = 1;

  var nativo = window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (nativo || reduce) return;

  function mover() {
    document.querySelectorAll('.tpf[data-anima="1"] [data-tpf]').forEach(function (sec) {
      var track = sec.querySelector('[data-tpf-track]');
      if (!track) return;
      var caja = sec.getBoundingClientRect();
      var recorrido = caja.height - window.innerHeight;
      if (recorrido <= 0) return;
      var t = Math.min(1, Math.max(0, -caja.top / recorrido));
      var sobra = track.scrollWidth - sec.clientWidth;
      if (sobra <= 0) return;
      track.style.transform = 'translate3d(' + (-sobra * t) + 'px,0,0)';
    });
  }

  var pedido = false;
  function alScroll() {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(function () { pedido = false; mover(); });
  }
  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', alScroll);
  document.addEventListener('shopify:section:load', alScroll);
  mover();
})();

  } catch(e) { console.error(e); }
})();
})();
